import { render, staticRenderFns } from "./LikertScaleForm.vue?vue&type=template&id=03bbff38"
import script from "./LikertScaleForm.vue?vue&type=script&lang=js"
export * from "./LikertScaleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports